import useSWR from 'swr';
import { authService } from '@/services';
import { AwaitedReturnType, FetchErrorsType } from '@/types';
import { config } from '@/config';

const API_URL = config.api.url.auth;

export const use2faMethods = () => {
    return useSWR<AwaitedReturnType<typeof authService.get2faMethods>, FetchErrorsType>(
        [`${API_URL}/2fa/methods`],
        () => authService.get2faMethods(),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
        },
    );
};
